import { ReactNode } from "react"

import LoadingSpinner from "@/app/components/LoadingSpinner"
import "./sectionContainer.scss"

export default function SectionContainer({
  title,
  children,
  sectionMenu,
  loading,
}: {
  title: string
  children: ReactNode
  sectionMenu?: ReactNode
  loading?: boolean
}) {
  return (
    <div className="ReportSectionCont">
      <div className="ReportSectionTitleCont">
        <h3>{title}</h3>
        {sectionMenu}
      </div>
      <div className="ReportSectionContentCont">{children}</div>

      {loading && (
        <div className="MuiLoadingSpinnerCont">
          <LoadingSpinner />
        </div>
      )}
    </div>
  )
}
